import { PageListProps } from '@templates';

export enum TenantStatuses {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export interface TenantListItem {
  id: number;
  fantasyName: string;
  status: TenantStatuses;
  document: string;
  tenantAliasId: string;
  createdAt: string;
}

export type TenantListProps = PageListProps<TenantListItem>;
